import {Capacitor} from "@capacitor/core";
import {Style, StatusBar} from "@capacitor/status-bar";
import {EdgeToEdge} from "@squareetlabs/capacitor-android-edge-to-edge";

const isAndroid = () => Capacitor.getPlatform() === 'android';

const appStatusBarUpdate = async () => {
    if (isAndroid()) {
        // @capacitor/status-bar's setBackgroundColor() is a no-op on Android 16
        // under forced edge-to-edge, so the color/appearance is set via this plugin instead.
        await EdgeToEdge.setStatusBarAppearance({light: true});
        await EdgeToEdge.setStatusBarColor({color: '#FF262532'});
        return;
    }

    const info = await StatusBar.getInfo();

    if (info.style !== Style.Dark) {
        StatusBar.setStyle({
            style: Style.Dark
        });
    }

    if (info.color !== '#262532') {
        StatusBar.setBackgroundColor({
            color: '#262532'
        });
    }
}

const loginStatusBarUpdate = async () => {
    if (isAndroid()) {
        await EdgeToEdge.setStatusBarAppearance({light: false});
        await EdgeToEdge.setStatusBarColor({color: '#FFFFFFFF'});
        return;
    }

    const info = await StatusBar.getInfo();

    if (info.style !== Style.Light) {
        StatusBar.setStyle({
            style: Style.Light
        });
    }

    if (info.color !== '#ffffff') {
        StatusBar.setBackgroundColor({
            color: '#ffffff'
        });
    }
}

export {appStatusBarUpdate, loginStatusBarUpdate}